import React from "react";
import ForgotPassword from "../../views/ForgotPassword";

const ForgotPasswordPage = () => {
  return (
    <div className=" h-screen">
      <ForgotPassword />
    </div>
  );
};

export default ForgotPasswordPage;
